import { render, staticRenderFns } from "./HistoryPop.vue?vue&type=template&id=06f86528&"
import script from "./HistoryPop.vue?vue&type=script&lang=ts&"
export * from "./HistoryPop.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports